export const SESSION_EXPIRED_MESSAGE = 'Your session expired, reload to sign in again';

export function isExpiredSessionStatus(status) {
	return status === 401 || status === 419;
}

export function isAdminStaffPath(pathname) {
	const path = pathname.startsWith('/') ? pathname : `/${pathname}`;

	return path === '/admin' || path.startsWith('/admin/') || path === '/staff' || path.startsWith('/staff/');
}

export function registerLivewireSessionExpiryHook(Livewire, {
	prompt = window.alert.bind(window),
	reload = () => window.location.reload(),
	currentPath = () => (typeof window === 'undefined' ? '' : window.location.pathname),
} = {}) {
	if (! Livewire?.hook) {
		return;
	}

	Livewire.hook('request', ({ fail }) => {
		fail(({ status, preventDefault }) => {
			if (! isExpiredSessionStatus(status) || ! isAdminStaffPath(currentPath())) {
				return;
			}

			preventDefault?.();
			prompt(SESSION_EXPIRED_MESSAGE);
			reload();
		});
	});
}
